/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GenderAndSterilizationV2Model } from './GenderAndSterilizationV2Model';
import {
    GenderAndSterilizationV2ModelFromJSON,
    GenderAndSterilizationV2ModelFromJSONTyped,
    GenderAndSterilizationV2ModelToJSON,
} from './GenderAndSterilizationV2Model';
import type { PetBreedModel } from './PetBreedModel';
import {
    PetBreedModelFromJSON,
    PetBreedModelFromJSONTyped,
    PetBreedModelToJSON,
} from './PetBreedModel';
import type { PetBreedSizeModel } from './PetBreedSizeModel';
import {
    PetBreedSizeModelFromJSON,
    PetBreedSizeModelFromJSONTyped,
    PetBreedSizeModelToJSON,
} from './PetBreedSizeModel';
import type { PetMedicalConditionModel } from './PetMedicalConditionModel';
import {
    PetMedicalConditionModelFromJSON,
    PetMedicalConditionModelFromJSONTyped,
    PetMedicalConditionModelToJSON,
} from './PetMedicalConditionModel';
import type { PetMedicationAllergyModel } from './PetMedicationAllergyModel';
import {
    PetMedicationAllergyModelFromJSON,
    PetMedicationAllergyModelFromJSONTyped,
    PetMedicationAllergyModelToJSON,
} from './PetMedicationAllergyModel';
import type { PetMedicationModel } from './PetMedicationModel';
import {
    PetMedicationModelFromJSON,
    PetMedicationModelFromJSONTyped,
    PetMedicationModelToJSON,
} from './PetMedicationModel';
import type { PetTypeReferenceModel } from './PetTypeReferenceModel';
import {
    PetTypeReferenceModelFromJSON,
    PetTypeReferenceModelFromJSONTyped,
    PetTypeReferenceModelToJSON,
} from './PetTypeReferenceModel';
import type { PetTypeV2FormConfigModel } from './PetTypeV2FormConfigModel';
import {
    PetTypeV2FormConfigModelFromJSON,
    PetTypeV2FormConfigModelFromJSONTyped,
    PetTypeV2FormConfigModelToJSON,
} from './PetTypeV2FormConfigModel';
import type { SubmitterModel } from './SubmitterModel';
import {
    SubmitterModelFromJSON,
    SubmitterModelFromJSONTyped,
    SubmitterModelToJSON,
} from './SubmitterModel';

/**
 * 
 * @export
 * @interface FormFieldCheckboxValueModel
 */
export interface FormFieldCheckboxValueModel {
    /**
     * 
     * @type {number}
     * @memberof FormFieldCheckboxValueModel
     */
    id: number;
    /**
     * 
     * @type {SubmitterModel}
     * @memberof FormFieldCheckboxValueModel
     */
    submitter?: SubmitterModel;
    /**
     * 
     * @type {string}
     * @memberof FormFieldCheckboxValueModel
     */
    name: string;
    /**
     * Only modifiable during update.
     * @type {boolean}
     * @memberof FormFieldCheckboxValueModel
     */
    markForDelete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldCheckboxValueModel
     */
    pharmacyEligible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldCheckboxValueModel
     */
    vetDietEligible?: boolean;
    /**
     * 
     * @type {PetBreedSizeModel}
     * @memberof FormFieldCheckboxValueModel
     */
    size?: PetBreedSizeModel;
    /**
     * 
     * @type {PetTypeReferenceModel}
     * @memberof FormFieldCheckboxValueModel
     */
    type: PetTypeReferenceModel;
    /**
     * 
     * @type {string}
     * @memberof FormFieldCheckboxValueModel
     */
    gender: FormFieldCheckboxValueModelGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldCheckboxValueModel
     */
    sterilization: boolean;
}


/**
 * @export
 */
export const FormFieldCheckboxValueModelGenderEnum = {
    Unknown: 'UNKNOWN',
    Male: 'MALE',
    Female: 'FEMALE'
} as const;
export type FormFieldCheckboxValueModelGenderEnum = typeof FormFieldCheckboxValueModelGenderEnum[keyof typeof FormFieldCheckboxValueModelGenderEnum];


/**
 * Check if a given object implements the FormFieldCheckboxValueModel interface.
 */
export function instanceOfFormFieldCheckboxValueModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "gender" in value;
    isInstance = isInstance && "sterilization" in value;

    return isInstance;
}

export function FormFieldCheckboxValueModelFromJSON(json: any): FormFieldCheckboxValueModel {
    return FormFieldCheckboxValueModelFromJSONTyped(json, false);
}

export function FormFieldCheckboxValueModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldCheckboxValueModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'submitter': !exists(json, 'submitter') ? undefined : SubmitterModelFromJSON(json['submitter']),
        'name': json['name'],
        'markForDelete': !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
        'pharmacyEligible': !exists(json, 'pharmacyEligible') ? undefined : json['pharmacyEligible'],
        'vetDietEligible': !exists(json, 'vetDietEligible') ? undefined : json['vetDietEligible'],
        'size': !exists(json, 'size') ? undefined : PetBreedSizeModelFromJSON(json['size']),
        'type': PetTypeReferenceModelFromJSON(json['type']),
        'gender': json['gender'],
        'sterilization': json['sterilization'],
    };
}

export function FormFieldCheckboxValueModelToJSON(value?: FormFieldCheckboxValueModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'submitter': SubmitterModelToJSON(value.submitter),
        'name': value.name,
        'markForDelete': value.markForDelete,
        'pharmacyEligible': value.pharmacyEligible,
        'vetDietEligible': value.vetDietEligible,
        'size': PetBreedSizeModelToJSON(value.size),
        'type': PetTypeReferenceModelToJSON(value.type),
        'gender': value.gender,
        'sterilization': value.sterilization,
    };
}

